import { render, staticRenderFns } from "./NewsSection.vue?vue&type=template&id=03ae760c&scoped=true"
import script from "./NewsSection.vue?vue&type=script&lang=js"
export * from "./NewsSection.vue?vue&type=script&lang=js"
import style0 from "./NewsSection.vue?vue&type=style&index=0&id=03ae760c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae760c",
  null
  
)

export default component.exports